import type { EligibilityResponse } from "../api/get-eligibility";
import type { OnboardingProgressResponse } from "../api/get-onboarding-progress";

/** Eligible cohort member who has not dismissed onboarding. */
export function isOnboardingActive(
  eligibility: EligibilityResponse | null | undefined
): boolean {
  return eligibility?.active === true && eligibility.dismissed !== true;
}

export function shouldRedirectToOnboarding(
  eligibility: EligibilityResponse | null | undefined
): "onboarding" | "app" {
  if (!eligibility?.active || eligibility.dismissed) {
    return "app";
  }
  return "onboarding";
}

export function shouldShowSidebarCta(
  eligibility: EligibilityResponse | null | undefined,
  progress: OnboardingProgressResponse | undefined
): boolean {
  if (eligibility?.active !== true || progress == null) {
    return false;
  }
  const graduated = progress.step === "done" && eligibility.dismissed === true;
  return !graduated;
}

export function canEnterOnboardingRoute(
  eligibility: EligibilityResponse | null | undefined
): boolean {
  return eligibility?.active === true;
}
